// extracted by mini-css-extract-plugin
export var label = "_co-2";
export var slideContainer = "_co-0";
export var slider = "_co-1";